(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './Modal'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./Modal'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Modal);
    global.index = mod.exports;
  }
})(this, function (exports, _Modal) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Modal = undefined;

  var _Modal2 = _interopRequireDefault(_Modal);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.Modal = _Modal2.default;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Modal/index.js
// module id = 879
// module chunks = 1